module.exports = __webpack_public_path__ + "static/media/cliff.fd3ef43f.png";